export const blockIconsAndroidPasswordNew = (
	<span className='material-symbols-outlined'>password</span>
);
